module.exports = __webpack_public_path__ + "static/reward-2-f58900b8cf27bd1de76d8b65501db9fe.svg";